module.exports = __webpack_public_path__ + "img/esim-red.8eea09a5.svg";